var map = {
	"./Circle.mp3": 7684,
	"./Diamond.mp3": 8305,
	"./Hexagon.mp3": 2032,
	"./Octagon.mp3": 3067,
	"./Oval.mp3": 1805,
	"./Pentagon.mp3": 9920,
	"./Rectangle.mp3": 9552,
	"./Square.mp3": 3337,
	"./Star.mp3": 9933,
	"./Triangle.mp3": 317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6091;